<template>
  <div>
    	<div id="wrapper">
        <img src="../assets/my/2025.png" style="height:120px;"/>
    		<!--div id="content" style="height:820px;" -->
    		<div id="content">
    			<p>
    				<strong style="color: black;" >
    				    Committees
    				</strong>
    			</p>
    			<div calss="">
                    <b class="my-c">Program chairs or co-chairs:</b>
    			</div>

               <table width="100%" border="0" cellspacing="4" cellpadding="0">
                               <tr>
                                   <td width="5%">&nbsp;</td>
                                   <td width="20%"><span class="body_text"><a href="mailto: h.zheng@ulster.ac.uk">Prof. Huiru (Jane) Zheng</a></span></td>
                                   <td width="75%"><span class="body_text">Professor School of Computing Ulster University UK.</span></td>
                               </tr>
               				<tr>
                                   <td width="5%">&nbsp;</td>
                                   <td width="20%"><span class="body_text"><a href="mailto: zhongming.zhao@uth.tmc.edu">Prof. Zhongming Zhao</a></span></td>
                                   <td width="75%"><span class="body_text">Professor McWilliams School of Biomedical Informatics The University of Texas and Vanderbilt University USA.</span></td>
                               </tr>
                               <tr>
                                   <td width="5%">&nbsp;</td>
                                   <td width="20%"><span class="body_text"><a href="mailto: xiaoming@scu.edu.cn">Prof. Ming Xiao</a></span></td>
                                   <td width="75%"><span class="body_text">College of Computer Science Sichuan University Chengdu China.</span></td>
                               </tr>
                           </table>

    			<div>
                    <b class="my-c">Program committee members</b>
    			</div >
            <table width="100%" border="0" cellspacing="4" cellpadding="0">
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Patrizo Arrigo</span></td>
                    <td width="75%"><span class="body_text">National Research Council (ISMAC) Italy</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Jaine Blayney</span></td>
                    <td width="75%"><span class="body_text">Centre for Cancer Research & Cell Biology Queen’s University Belfast UK</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Prof. Danail Bonchev</span></td>
                    <td width="75%"><span class="body_text">Center for the Study of Biological Complexity Virginia Commonwealth University USA</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Fiona Browne</span></td>
                    <td width="75%"><span class="body_text">Ulster University UK</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Minghua Deng</span></td>
                    <td width="75%"><span class="body_text">Center for Theoretical Biology Peking University China</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Prof. Werner Dublizky</span></td>
                    <td width="75%"><span class="body_text">Biomedical Research Institute University of Ulster UK</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Xiaodan Fan</span></td>
                    <td width="75%"><span class="body_text">Department of Statistics Chinese University of Hong Kong</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Luca Giancardo</span></td>
                    <td width="75%"><span class="body_text">University of Texas USA</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Kun Huang</span></td>
                    <td width="75%"><span class="body_text">Department of Biomedical Informatics Ohio State University USA</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Peilin Jia</span></td>
                    <td width="75%"><span class="body_text">Beijing Institute of Genomics China</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Vladimir A. Kuznetsov</span></td>
                    <td width="75%"><span class="body_text">Bioinformatics Institute/A*STAR Singapore</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Hyunju Lee</span></td>
                    <td width="75%"><span class="body_text">Gwangju Institute of Science and Technology Korea</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Kang Li</span></td>
                    <td width="75%"><span class="body_text">School of Electronics Electrical Engineering and Computer Sciences Queen’s University Belfast UK</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Shao Li</span></td>
                    <td width="75%"><span class="body_text">MOE Key Laboratory of Bioinformatics and Bioinformatics Division Tsinghua University China</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Prof. Xiaohui Liu</span></td>
                    <td width="75%"><span class="body_text">School of Information Systems and Computing Brunel University UK</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Antonio Sanfilippo</span></td>
                    <td width="75%"><span class="body_text">Computational and Statistical Analytics Division Pacific Northwest National Laboratory USA</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Lukas Simon</span></td>
                    <td width="75%"><span class="body_text">Baylor College of Medicine USA</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Momiao Xiong</span></td>
                    <td width="75%"><span class="body_text">University of Texas Health Science Center at Houston USA</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Jun Wan</span></td>
                    <td width="75%"><span class="body_text">Indiana University USA</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Haiying Wang</span></td>
                    <td width="75%"><span class="body_text">Computer Science Research Institute University of Ulster UK</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Ying Wang</span></td>
                    <td width="75%"><span class="body_text">Xiamen University China</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Yong Wang</span></td>
                    <td width="75%"><span class="body_text">Academy of Mathematics and Systems Science Chinese Academy of Sciences China</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Hong Yue</span></td>
                    <td width="75%"><span class="body_text">Department of Electronic and Electrical Engineering University of Strathclyde UK</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Xingming Zhao</span></td>
                    <td width="75%"><span class="body_text">Fudan University China</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Shihua Zhang</span></td>
                    <td width="75%"><span class="body_text">Chinese Academy of Sciences China</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Feng Zeng</span></td>
                    <td width="75%"><span class="body_text">Xiamen University China</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Prof. Wei Chen</span></td>
                    <td width="75%"><span class="body_text">Chengdu University of Traditional Chinese Medicine China</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Prof. Jin Liu</span></td>
                    <td width="75%"><span class="body_text">School of Computer Science and Engineering Central South University China</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Prof. Liang Yu</span></td>
                    <td width="75%"><span class="body_text">School of Computer Science and Technology Xidian University China</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Yujie You</span></td>
                    <td width="75%"><span class="body_text">Sichuan University of Science & Engineering China</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Guangdi Liu</span></td>
                    <td width="75%"><span class="body_text">Zhengzhou University China</span></td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                </tr>

                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Dr. Yuan Lin</span></td>
                    <td width="75%"><span class="body_text">Kristiania University of Applied Science Norway</span></td>
                </tr>


                <tr>
                    <td>&nbsp;</td>
                </tr>

                <tr>
                    <td width="5%">&nbsp;</td>
                    <td width="20%"><span class="body_text">Prof.Pijush Kanti Dutta Pramanik  </span></td>
                    <td width="75%"><span class="body_text">School of Computer Science and Engineering, Galgotias University, India  </span></td>
                </tr>




            </table>

    		</div>
    	</div>

      <footer-component></footer-component>
  </div>
</template>

<script>
  import FooterComponent from '@/components/Foot/footer.vue'

  export default {
    components: {
      FooterComponent
    }
  }
</script>

<style>

</style>
